<template>
  <div class="flex flex-col w-full">
    <!-- Layout responsivo: una columna por defecto, dos columnas en md -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
      <!-- Columna izquierda -->
      <div class="flex flex-col space-y-4">

        <expandable-panel :item="_getConfigOptions('select_activity')">
          <linked-entities
            :project-id="projectId"
            :entity="entity"
            :entityType="entityType"
            :showButtonUnlinkAll="showButtonUnlinkAll"
          />
        </expandable-panel>

      </div>

      <!-- Columna derecha -->
      <div class="flex flex-col space-y-4">
      </div>
    </div>
  </div>
</template>

<script>
import LinkedEntities from './linked-entities.vue';
import ExpandablePanel from '../layer-statuses/expandable-panel.vue';

export default {
  name: 'PictogramActivitySettings',

  components: {
    LinkedEntities,
    ExpandablePanel,
  },

  props: {
    // Number o String: `project_id` de la API puede venir como cadena.
    projectId: { type: [Number, String], required: true },
    entity: { type: Object, required: true },
    entityType: { type: String, required: true },
    showButtonUnlinkAll: { type: Boolean, required: false, default: false }
  },

  data() {
    return {

    }
  },

  computed: {

  },

  methods: {
    _getConfigOptions(code) {
      const options = [
        {
          code: 'select_activity',
          name: 'Seleccionar actividad',
          description: "Seleccionar actividad para asignar el pictograma.",
          icon: 'link',
          order: 0,
          type: 'item',
        }
      ];
      return options.find(option => option.code === code) || null;
    },
  }
}
</script>
